define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/ListBuilderActions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    emails: Immutable.List(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_AUTO_RESPONSE_EMAILS] = (state, action) => {
    return state.set('emails', Immutable.fromJS(action.autoResponseEmails));
  };

  actionHandlers[Actions.RECEIVE_AUTO_RESPONSE_TEMPLATES] = (state, action) => {
    return state.set('templates', Immutable.fromJS(action.autoResponseTemplates));
  };

  actionHandlers[Actions.ADD_AUTO_RESPONSE_EMAIL] = (state, action) => {
    const { autoResponseEmail } = action;
    const list = state.get('emails');
    let newList = list;

    // wipe an existing email with the same id if needed
    const listJS = newList.toJS();
    const autoResponseEmailId = autoResponseEmail.id.trim().toLowerCase();
    const existingEmail = _.find(listJS, email => email.id.trim().toLowerCase() === autoResponseEmailId);
    const index = _.indexOf(listJS, existingEmail);

    if (existingEmail) {
      newList = newList.delete(index);
    }

    // disable other default if this one is set to default
    if (autoResponseEmail.default === true) {
      let defaultIndexes = [];
      newList.forEach((item, index) => { if (item.get("default") === true) defaultIndexes.push(index); });
      defaultIndexes.forEach(index => { newList = newList.setIn([index, "default"], null); });
    }

    // now push the new email
    newList = newList.push(Immutable.fromJS(autoResponseEmail));

    return state.set('emails', newList);
  };

  actionHandlers[Actions.DELETE_AUTO_RESPONSE_EMAIL] = (state, action) => {
    const list = state.get('emails');
    const index = list.toJS().map(o => o.id).indexOf(action.autoResponseEmailId);
    let newList = list;

    if (index >= 0) {
      newList = newList.delete(index);
    }
    return state.set('emails', newList);
  };

  return Util.createReducer(initialState, actionHandlers);
});
